
class BrowserStorageService {
    private prefix: string = 'pf-';

    public putLocal(key: string, value: any): void {
        value = JSON.stringify(value);

        localStorage.setItem(this.prefix + key, value);
    }

    public pullLocal(key: string): any {
        let retrievedObject = localStorage.getItem(this.prefix + key);

        if (!retrievedObject) {
            return null;
        }

        try {
            retrievedObject = JSON.parse(retrievedObject);
            return retrievedObject;
        } catch (e) {
            return null;
        }
    }

    public removeLocal(key: string): void {
        localStorage.removeItem(this.prefix + key);
    }

    public putSession(key: string, value: any): void {
        value = JSON.stringify(value);

        sessionStorage.setItem(this.prefix + key, value);
    }

    public pullSession(key: string): any {
        let retrievedObject = sessionStorage.getItem(this.prefix + key);

        if (!retrievedObject) {
            return null;
        }

        try {
            retrievedObject = JSON.parse(retrievedObject);
            return retrievedObject;
        } catch (e) {
            return null;
        }
    }
}

export const BrowserStorage = new BrowserStorageService();
